var map = {
	"./icon-bar-chart.svg": 66,
	"./icon-box.svg": 67,
	"./icon-cancelamento.svg": 90,
	"./icon-cliente-alternativo.svg": 43,
	"./icon-cliente.svg": 91,
	"./icon-compra.svg": 92,
	"./icon-custo.svg": 93,
	"./icon-devolucao.svg": 94,
	"./icon-line-chart.svg": 68,
	"./icon-nfe.svg": 95,
	"./icon-pagamento.svg": 96,
	"./icon-pie-chart.svg": 69,
	"./icon-produto-alternativo.svg": 49,
	"./icon-produto.svg": 97,
	"./icon-recebimento.svg": 98,
	"./icon-store.svg": 99,
	"./icon-ticket.svg": 100,
	"./icon-venda.svg": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;